import { SECTION_TITLE } from '@/lib/typography'
import type { Section } from '@/types/website'
import { SECTION_PADDING, SITE_CONTAINER } from '@/components/layout/container'
import { MaybeHtml } from '@/components/blocks/maybe-html'
import { cn } from '@/lib/utils'

type StatItem = { value?: string; label?: string }

/**
 * Багануудыг ЛИТЕРАЛ классаар бичнэ.
 *
 * Өмнө нь `lg:grid-cols-${columns}` гэж угсарч байсан. Tailwind нь эх кодыг
 * статикаар уншдаг тул угсарсан класс CSS-д ОГТ үүсдэггүй — алдаа ч гарахгүй,
 * зүгээр л ажиллахгүй. `columns=3` ажиллаж байсан нь зөвхөн `lg:grid-cols-3`
 * сайтын өөр газар байдгийн ач; `columns=6` бол чимээгүй унаж 2 багана
 * болж гацна.
 */
const COLUMN_CLASS: Record<string, string> = {
  '2': 'lg:grid-cols-2',
  '3': 'lg:grid-cols-3',
  '4': 'lg:grid-cols-4',
  '5': 'lg:grid-cols-5',
  '6': 'lg:grid-cols-6'
}

/** Тоон үзүүлэлтийн сүлжээ. */
export const SectionStats = ({ section }: { section: Section }) => {
  const items = section.items as StatItem[]

  if (items.length === 0) return null

  const columns = COLUMN_CLASS[String(section.settings.columns ?? 3)] ?? COLUMN_CLASS['3']

  return (
    <section>
      <div className={cn(SITE_CONTAINER, SECTION_PADDING)}>
        <SectionHeading eyebrow={section.eyebrow} heading={section.heading} subheading={section.subheading} />

        <dl className={cn('bg-border mt-12 grid gap-px overflow-hidden rounded-xl border sm:grid-cols-2', columns)}>
          {items.map((item, i) => (
            <div key={i} className='bg-background flex flex-col gap-2 p-8'>
              <dt className='text-muted-foreground text-xl'>{item.label}</dt>
              <dd className='text-3xl font-semibold tracking-tight'>{item.value}</dd>
            </div>
          ))}
        </dl>
      </div>
    </section>
  )
}

export const SectionHeading = ({
  eyebrow,
  heading,
  subheading,
  centered = false
}: {
  eyebrow?: string | null
  heading?: string | null
  subheading?: string | null

  /** Голлуулах эсэх. Дэд гарчгийн өргөний хязгаар нь голлоход `mx-auto` шаардана. */
  centered?: boolean
}) => (
  <div className={cn('flex flex-col gap-3', centered && 'items-center text-center')}>
    {eyebrow && (
      <span className='text-muted-foreground inline-flex w-fit items-center gap-2.5 text-xl font-medium tracking-widest uppercase'>
        <span className='bg-primary size-2.5 rounded-full' aria-hidden='true' />
        {eyebrow}
      </span>
    )}
    {heading && <h2 className={SECTION_TITLE}>{heading}</h2>}
    <MaybeHtml text={subheading} className='text-muted-foreground max-w-2xl text-justify text-xl hyphens-auto' />
  </div>
)
